module.exports = __webpack_public_path__ + "static/media/club-master-oro.295d5d34.png";